module.exports = __webpack_public_path__ + "img/SWT.4535a799.svg";